import FormControlLabel from './FormControlLabel'

export * from './FormControlLabel'
export default FormControlLabel
